import { gql } from '@apollo/client';

export const fetchEntitlementListForDownloadCSV = gql`
  query fetchEntitlementListForDownloadCSV(
    $id: ID!
    $searchOptions: ConnectionSearchOptions
    $filterOptions: [FilterOption]
    $isRestricted: Boolean
  ) {
    transactionAccount(id: $id) {
      id
      productSubscriptionsInPPC(searchOptions: $searchOptions, filterOptions: $filterOptions) {
        nodes {
          id
          activeUsers
          baseProduct
          createdDate
          billingStatus
          entitlementNumber
          latestPeriodEndDate
          productId
          cloudSiteHostname
          billingFrequency
          edition
          billingGroupId
          linkedAppsId
          orgName
          endCustomerContacts(isRestricted: $isRestricted) {
            name
          }
          subscriptionTimestamps {
            firstTrialStartTimestamp
            lastTrialEndTimestamp
          }
          upgradeTrial {
            startTimestamp
            endTimestamp
          }
        }
      }
    }
  }
`;
